var viewer_rtlignore_default = {
  "gallery_container": "A-fai",
  "imageTitleContainer": "IwJ-F",
  "clickableItem": "eEH1t",
  "prerender": "RnBkW",
  "expandButton": "Yu54S",
  "itemContainer": "BQbYZ",
  "expandIcon": "NLMTz",
  "itemOverlay": "AQMLU",
  "imageTitle": "ffJVU",
  "pointer": "DB5-W",
  "fadeIn": "QSQ2d",
  "changing_background": "SOPKF"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
